import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M-3,-1h0.5v0.5h-0.5zM-3.5,-0.5h1v0.5h-1zM3,-0.5h0.5v0.5h-0.5zM-3.5,0h1.5v0.5h-1.5zM2,0h1.5v0.5h-1.5zM-2.5,0.5h5v0.5h-5z',
    },
    {
      paint: 'windmill',
      d: 'M-2,-7h1.5v0.5h-1.5zM-2,-6.5h1v0.5h-1zM-2.5,-6h1.5v2.5h-1.5zM2,-6h0.5v0.5h-0.5zM-2.5,-3.5h1v0.5h-1zM-2,-3h0.5v0.5h-0.5zM-2.5,-2h1v0.5h-1zM-3,-1.5h1.5v0.5h-1.5zM-2.5,-1h1v1h-1z',
    },
    {
      paint: 'wallShade',
      d: 'M0,-10.5h0.5v1h-0.5zM1.5,-8.5h0.5v0.5h-0.5zM-1.5,-8h0.5v0.5h-0.5zM1,-7.5h1v0.5h-1zM0.5,-7h0.5v0.5h-0.5zM-0.5,-6.5h0.5v0.5h-0.5zM0.5,-6.5h1.5v1h-1.5zM0.5,-5.5h2v2.5h-2zM-0.5,-4.5h0.5v1.5h-0.5zM-1.5,-3.5h0.5v1h-0.5zM0.5,-3h1.5v0.5h-1.5zM0.5,-2h2.5v0.5h-2.5zM0,-1.5h3v1.5h-3zM-2,0h0.5v0.5h-0.5zM0,0h2v0.5h-2z',
    },
    { paint: 'roofA', d: 'M1,-9.5h0.5v0.5h-0.5zM1,-9h1v0.5h-1zM0.5,-8.5h1v0.5h-1z' },
    {
      paint: 'roofB',
      d: 'M-1,-10.5h0.5v0.5h-0.5zM-1.5,-10h1v1h-1zM-2,-9h1.5v0.5h-1.5zM-1,-8.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-0.5,-13.5h0.5v3.5h-0.5zM0,-8.5h0.5v0.5h-0.5zM-0.5,-8h1v1h-1zM2,-8h4v0.5h-4zM-6,-7.5h4v0.5h-4zM0,-5.5h0.5v1h-0.5zM-1.5,-2h0.5v0.5h-0.5zM0,-2h0.5v0.5h-0.5zM-1.5,-1.5h1.5v1.5h-1.5zM-1,0h1v0.5h-1z',
    },
    {
      paint: 'boat',
      d: 'M-3,-3h1v0.5h-1zM2,-3h1v0.5h-1zM-3,-2.5h2v0.5h-2zM0.5,-2.5h2.5v0.5h-2.5z',
    },
    {
      paint: 'fence',
      d: 'M0,-13.5h0.5v0.5h-0.5zM0,-12.5h0.5v0.5h-0.5zM0,-11h0.5v0.5h-0.5zM-0.5,-10h0.5v0.5h-0.5zM-0.5,-9.5h1v1h-1zM-0.5,-8.5h0.5v0.5h-0.5zM-6,-8h0.5v0.5h-0.5zM-5,-8h0.5v0.5h-0.5zM-3.5,-8h0.5v0.5h-0.5zM-2,-8h0.5v0.5h-0.5zM-1,-8h0.5v0.5h-0.5zM0.5,-8h1.5v0.5h-1.5zM-2,-7.5h1.5v0.5h-1.5zM0.5,-7.5h0.5v0.5h-0.5zM3,-7.5h0.5v0.5h-0.5zM4.5,-7.5h0.5v0.5h-0.5zM5.5,-7.5h0.5v0.5h-0.5zM-0.5,-7h1v0.5h-1zM0,-6.5h0.5v0.5h-0.5zM-0.5,-6h1v0.5h-1zM-0.5,-5.5h0.5v1h-0.5zM0,-4.5h0.5v1.5h-0.5zM-3,-4h0.5v1h-0.5zM2.5,-4h0.5v1h-0.5zM-0.5,-3h1v1h-1zM-1,-2h1v0.5h-1zM-1.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'windBlade',
      d: 'M0.5,-13.5h1v0.5h-1zM0,-13h1.5v0.5h-1.5zM0.5,-12.5h1v0.5h-1zM0,-12h1.5v1h-1.5zM0.5,-11h1v1.5h-1zM0.5,-9.5h0.5v1h-0.5zM-6,-9h4v0.5h-4zM-6,-8.5h5v0.5h-5zM-5.5,-8h0.5v0.5h-0.5zM-4.5,-8h1v0.5h-1zM-3,-8h1v0.5h-1zM2,-7.5h1v0.5h-1zM3.5,-7.5h1v0.5h-1zM5,-7.5h0.5v0.5h-0.5zM1,-7h5v0.5h-5zM-1,-6.5h0.5v4.5h-0.5zM2,-6.5h4v0.5h-4z',
    },
  ],
  pixels: 314,
};
export const sprites: readonly PixelSprite[] = [variant0];
